/**
 * Error codes reported by the MFAController
 */
export var MultifactorAuthenticationErrorCode;
(function (MultifactorAuthenticationErrorCode) {
    /**
     * Indicates an attempt to use an invalid or used recovery code.
     */
    MultifactorAuthenticationErrorCode["InvalidRecoveryCode"] = "mfa/InvalidRecoveryCode";
})(MultifactorAuthenticationErrorCode || (MultifactorAuthenticationErrorCode = {}));
